function loadingImg($box: JQuery<HTMLElement>): void {
    let $imgs: JQuery<HTMLElement> = $box.find('.goods-img');

    $imgs.each(function(index, img): void {
        let $img: JQuery<HTMLElement> = $(img);
        let $imgWrap: JQuery<HTMLElement> = $img.closest('.goods-item');
        let url: string = $img.attr('src');
        let imgLoader: any = new Image();

        imgLoader.onload = function () {
            if (url === '//img.dmallcdn.com/dshop/202012/602ed622-7700-4c2b-a2ed-9ce47d93a4d3') {
                $imgWrap.addClass('img-error');
                return;
            }
            $imgWrap.removeClass('img-error');
        }

        imgLoader.onerror = function () {
            $imgWrap.addClass('img-error');
        }

        imgLoader.src = url;
    });
}

export {
    loadingImg
};
